// Firmware Updates translations for React Admin resource
export const firmwareUpdatesResource = {
  name: 'Firmware Update |||| Firmware Updates',
  fields: {
    id: 'ID',
    firmware_id: 'Firmware',
    firmware_version: 'Firmware Version',
    firmware_description: 'Firmware Description',
    site: 'Site',
    vendor: 'Vendor',
    model: 'Model',
    version: 'Version',
    target_type: 'Target Type',
    target_chargers: 'Target Chargers',
    target_sites: 'Target Sites',
    total_chargers: 'Total Chargers',
    charger_ids: 'Target Chargers',
    scheduled_at: 'Scheduled At',
    download_url: 'Download URL',
    retrieve_date: 'Retrieve Date',
    install_date: 'Install Date',
    status: 'Status',
    progress: 'Progress',
    created_at: 'Created At',
    updated_at: 'Updated At',
  },
};

// Custom firmware updates translations for components
export const firmwareUpdates = {
  subtitle: 'Manage firmware update jobs for chargers',
  validation: {
    firmware_required: 'Firmware selection is required',
    chargers_required: 'At least one charger must be selected',
    scheduled_at_future: 'Scheduled time must be in the future',
  },
  helpers: {
    firmware: 'Select the firmware version to deploy',
    site: 'Select the site where chargers are located',
    vendor: 'Select charger vendor',
    model: 'Select charger model',
    target_type: 'Choose how to select target chargers',
    target_chargers: 'Click to open dropdown, search, and select chargers using checkboxes',
    target_sites: 'Select sites - all chargers at these sites will be updated',
    chargers: 'Select target chargers for this update',
    scheduled_at: 'Schedule update time (leave empty for immediate)',
    retrieve_date: 'When the charger should download the firmware',
    install_date: 'When the charger should install and reboot (optional)',
    chargers_selected: 'chargers selected',
    no_chargers_found: 'No chargers match your search',
    no_chargers: 'No chargers available',
    select_site_first: 'Please select a site first to continue.',
    select_vendor_model_first: 'Please select vendor and model first to see available firmware.',
    no_chargers_vendor_model: 'No chargers with vendor information found at this site. Please ensure chargers have vendor and model data populated from OCPP.',
    no_models_available: 'No models available for this vendor.',
    no_chargers_combination: 'No chargers found for this site, vendor, and model combination.',
    no_firmware_available: 'No firmware available for {vendor} {model}. Please upload firmware for this vendor/model combination first.',
    firmware_count: '{count} available for {vendor} {model}',
  },
  sections: {
    firmware_selection: 'Firmware Selection',
    target_selection: 'Target Chargers',
    schedule: 'Update Schedule',
    status: 'Update Status',
  },
  actions: {
    create_update: 'Create Update Job',
    cancel: 'Cancel Update',
    query_status: 'Query Status',
    retry: 'Retry Failed',
    select_all: 'Select All',
    deselect_all: 'Deselect All',
    search_chargers: 'Search chargers...',
  },
  target_types: {
    charger: 'Individual Chargers',
    site: 'All Chargers at Sites',
    bulk: 'Bulk Update (All Compatible)',
  },
  statuses: {
    pending: 'Pending',
    sent: 'Sent',
    in_progress: 'In Progress',
    completed: 'Completed',
    downloading: 'Downloading',
    downloaded: 'Downloaded',
    installing: 'Installing',
    installed: 'Installed',
    installation_failed: 'Installation Failed',
    installationfailed: 'Installation Failed',
    download_failed: 'Download Failed',
    downloadfailed: 'Download Failed',
    cancelled: 'Cancelled',
  },
  warnings: {
    ocpp_command: 'This will trigger an OCPP UpdateFirmware command to all selected chargers. Make sure the firmware is compatible with the target chargers.',
    immediate_update: 'The firmware update will start immediately after creation. Please ensure no users are currently charging at the selected chargers.',
  },
  create: {
    title: 'Create Firmware Update',
    subtitle: 'Schedule firmware updates for chargers',
  },
  show: {
    title: 'Firmware Update Details',
    subtitle: 'View update status and progress',
  },
  list: {
    title: 'Firmware Updates',
    filters: {
      search: 'Search by version or charger',
      status: 'Status',
    },
    empty: {
      title: 'No firmware updates found',
      subtitle: 'Create your first firmware update job to begin updating chargers.',
    },
  },
  notifications: {
    created: 'Firmware update job created successfully',
    cancelled: 'Firmware update cancelled successfully',
    status_queried: 'Status query sent to chargers',
    failed_load_sites: 'Failed to load sites',
    failed_load_vendors_models: 'Failed to load charger vendors and models',
    failed_load_chargers: 'Failed to load chargers',
    error: {
      create: 'Failed to create firmware update',
      cancel: 'Failed to cancel firmware update',
      query_status: 'Failed to query status',
      no_chargers: 'No chargers selected',
    },
  },
  modals: {
    version_warning: {
      title: 'Firmware Version Warning',
      message: 'The following chargers already have firmware version equal to or newer than the selected version. Proceeding may result in a downgrade or reinstallation:',
      current_version: 'Current version',
      target_version: 'Target version',
      warning_text: 'Warning: Downgrading or reinstalling firmware may cause unexpected behavior or temporarily disrupt charging service. Are you sure you want to proceed?',
      cancel: 'Cancel',
      proceed: 'Proceed Anyway',
    },
    blocker: {
      title: 'Cannot Start Firmware Update',
      message: 'Firmware updates can only be performed when all chargers are idle (no active charging sessions)',
      info: 'Please wait for all chargers to become idle (no active charging sessions) before attempting firmware update.',
      ok: 'OK',
    },
  },
  toolbar: {
    save: 'Save',
  },
  charger_status: {
    title: 'Charger Update Status',
    charger_id: 'Charger ID',
    status: 'Status',
    last_updated: 'Last Updated',
    error_message: 'Error Message',
  },
};
